// Deterministic seeded PRNG (mulberry32). All simulation randomness must come
// from a World's rng instance so replays and headless playtests are reproducible.
export class RNG {
  constructor(seed = 1) { this.s = seed >>> 0; }
  next() {
    this.s = (this.s + 0x6d2b79f5) >>> 0;
    let t = this.s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  int(n) { return Math.floor(this.next() * n); }
  range(a, b) { return a + this.next() * (b - a); }
  pick(arr) { return arr[this.int(arr.length)]; }
  clone() { const r = new RNG(1); r.s = this.s; return r; }
}
